import { layout } from 'thewest/App.routing'

export const brandContentSegment = [
    layout.component({
        type: 'sierra',
        props: {
            verticalSpacing: 'gridGap',
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            cardLayout: [
                { type: 'hero', disableImageLazyLoad: false },
                'smallTitleNoTeaserNoKickerEdgeToEdge',
                'smallTitleNoTeaserNoKickerEdgeToEdge',
            ],
            dataDefinitionArgs: {
                type: 'curation',
                name: 'brand-partners',
                offset: 0,
                pageSize: 3,
            },
            sectionHeader: {
                heading: 'Brand Partners',
            },
        },
    }),

    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fixedRatios: ['16:9'],
            intermediateColumns: 2,
            finalColumns: 4,
            hasBackground: true,
            hideKicker: true,
            cardLayout: [
                ['teaserEdgeToEdge'],
                ['teaserEdgeToEdge'],
                ['noImageWithBackground', 'noImageWithBackground'],
                ['teaserEdgeToEdge'],
            ],
            cardOrientation: { type: 'Landscape-Portrait' },
            dataDefinitionArgs: {
                type: 'curation',
                name: 'brand-partners',
                offset: 3,
                pageSize: 5,
            },
        },
    }),
]
